import { useMemo, useRef, useState } from 'react'
import ReportsPagesContent from 'src/component/ReportsPagesContent'
import { GetPatientDecisions } from 'src/requests/DecisionMedicine'
import { Original } from 'src/common/Common.Type'
import BaseBtn from 'src/component/ActionBtn/BaseBtn'
import CMedicialNotesPopup from './Popup/CMedicialNotesPopup'
import { dateFormatter, getMonthNumber } from 'src/utils'
import { ActionsId, DecisionTypes } from 'src/common/constants'
import { useLocation } from 'react-router-dom'


const AddMedicine = () => {

  const [rowId, setRowId] = useState<number | null>(null)
  const [hospitalId, setHospitalId] = useState<number | null>(null)
  const prevHospital = useRef<number | null>(null)
  const updateModal = useRef<any>(null)
  const { state } = useLocation()

  const columns = useMemo(() => [
    {
      Header: "patientName",
      accessor: "patientName"
    },
    {
      Header: "patientNationalId",
      accessor: "patientNationalId"
    },
    {
      Header: "decisionId",
      accessor: "number"
    },
    {
      Header: "lastDeliveryDate",
      Cell: ({ row: { original } }: Original) => (dateFormatter(original.lastDeliveryDate, "ar")),
    },
    {
      Header: "diagnosis",
      accessor: "diagnosis"
    },
    {
      Header: "decisionPeriod",
      Cell: ({ row: { original } }: Original) => {
        return original?.decisionTypeId === DecisionTypes.Normal ? (
          <>
            {dateFormatter(original?.decisionStartDate, "ar", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })}
            ⬅️
            {dateFormatter(original?.decisionEndDate, "ar", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })}
          </>
        ) : (
          "-"
        );
      }
    },
    {
      Header: "monthNumber",
      Cell: ({ row: { original } }: Original) => original?.decisionTypeId === DecisionTypes.Normal ? getMonthNumber(original?.decisionStartDate) : "-"
    },
    {
      Header: "hospitalName",
      accessor: "hospitalName"
    },
    {
      Header: "decisionType",
      accessor: "decisionType"
    },
    {
      Header: "serviceType",
      accessor: "serviceType"
    },
    {
      Header: "action",
      id: ActionsId,
      Cell: ({ row: { original } }: Original) => (
        <>
          <BaseBtn
            icon={"material-symbols:edit-sharp"}
            className='update'
            ApplyAction={() => handleUpdateModal(original?.decisionId, original?.hospitalId)} isDisabled={false} />
        </>
      )
    }
  ], [state])

  const handleUpdateModal = (decisionId: number, hospitalId: number) => {
    updateModal.current.click()
    setHospitalId(hospitalId)
    setRowId(decisionId)
    if (hospitalId !== prevHospital.current) {
      prevHospital.current = hospitalId
    }
  }

  return (
    <>
      <CMedicialNotesPopup modalId={updateModal} setDecisionId={setRowId} hospitalId={hospitalId} decisionId={rowId} />
      <ReportsPagesContent needParams columns={columns} tableAPI={GetPatientDecisions} />
    </>
  )
}

export default AddMedicine